import React, { useEffect, useState } from "react";
import { useI18n } from "../../i18n/I18nContext";
import { api } from "../../lib/api";
import { BranchMap } from "../../components/MapField";
import { MapPin, Phone, Navigation } from "lucide-react";

export default function Branches() {
  const { t, localize, isAr } = useI18n();
  const [branches, setBranches] = useState([]);
  useEffect(() => { api.get("/branches").then((r) => setBranches(r.data)).catch(() => {}); }, []);
  return (
    <div className="mx-auto max-w-7xl px-4 py-12 sm:px-8">
      <h1 className="text-3xl font-bold text-slate-900 sm:text-4xl">{t("nav.branches")}</h1>
      <p className="mt-2 text-slate-500">{isAr ? "زُر أقرب فرع إليك أو اطلب التصوير المنزلي" : "Visit your nearest branch or request a home shoot"}</p>

      <div className="mt-8">
        <BranchMap branches={branches} isAr={isAr} />
      </div>

      <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-2">
        {branches.map((b) => (
          <div key={b.id} data-testid={`branch-card-${b.id}`} className="overflow-hidden rounded-2xl border border-border bg-white">
            <div className="aspect-[16/9] overflow-hidden"><img src="https://images.unsplash.com/photo-1721899311824-5b75161a82fa?crop=entropy&cs=srgb&fm=jpg&q=85" alt="" className="h-full w-full object-cover" /></div>
            <div className="p-6">
              <h3 className="text-xl font-bold text-slate-900">{localize(b, "name")}</h3>
              <p className="mt-2 inline-flex items-center gap-2 text-sm text-slate-500"><MapPin className="h-4 w-4 text-primary" /> {localize(b, "address")}، {localize(b, "city")}</p>
              <p className="mt-1 inline-flex items-center gap-2 text-sm text-slate-500" dir="ltr"><Phone className="h-4 w-4 text-[hsl(var(--brand-orange))]" /> {b.phone}</p>
              {b.lat && b.lng && (
                <a href={`https://www.google.com/maps/dir/?api=1&destination=${b.lat},${b.lng}`} target="_blank" rel="noreferrer" data-testid={`branch-directions-${b.id}`} className="mt-4 inline-flex items-center gap-1.5 rounded-full bg-primary/10 px-4 py-2 text-sm font-semibold text-primary hover:bg-primary/20">
                  <Navigation className="h-4 w-4" /> {isAr ? "الاتجاهات" : "Directions"}
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
